import { ArrayPick, englishCommaJoinStrings, toGrammaticalNumber } from "@hex-insights/core";
import { SharingRecord, SharingRecordNameFragment } from "../../../Utilities";
import * as UserGroupFormat from "../UserGroup";
import * as Fields from "./fields";

export { Fields };

/**
 * Formats the full name of the given instance.
 */
export function name(instance: SharingRecordNameFragment) {
	return instance.id;
}

export function preview(
	instance:
		| (Pick<SharingRecord, "isPublic"> & { userGroups: ArrayPick<SharingRecord["userGroups"], "name"> })
		| null
		| undefined,
	totalSharedUsers: number,
) {
	if (instance) {
		if (instance.isPublic) {
			return "Everyone";
		}

		if (instance.userGroups.length > 0) {
			if (instance.userGroups.length <= 2) {
				return englishCommaJoinStrings(instance.userGroups.map((e) => UserGroupFormat.name(e)));
			}
			return `${UserGroupFormat.name(instance.userGroups[0])} and ${instance.userGroups.length - 1} others`;
		}
		if (totalSharedUsers > 0) {
			return toGrammaticalNumber("People", totalSharedUsers, true);
		}
	}
	return "Private";
}
